
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_gwq0h_131pd_101",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_gwq0h_131pd_1",
  "trigger-expanded": "awsui_trigger-expanded_gwq0h_131pd_123",
  "icon": "awsui_icon_gwq0h_131pd_137",
  "root": "awsui_root_gwq0h_131pd_155",
  "expand-button": "awsui_expand-button_gwq0h_131pd_193",
  "expanded": "awsui_expanded_gwq0h_131pd_201",
  "icon-container": "awsui_icon-container_gwq0h_131pd_211",
  "icon-container-container": "awsui_icon-container-container_gwq0h_131pd_215",
  "wrapper": "awsui_wrapper_gwq0h_131pd_219",
  "wrapper-default": "awsui_wrapper-default_gwq0h_131pd_227",
  "wrapper-footer": "awsui_wrapper-footer_gwq0h_131pd_227",
  "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_131pd_231",
  "wrapper-container": "awsui_wrapper-container_gwq0h_131pd_234",
  "wrapper-compact": "awsui_wrapper-compact_gwq0h_131pd_238",
  "header-deprecated": "awsui_header-deprecated_gwq0h_131pd_251",
  "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_131pd_273",
  "header": "awsui_header_gwq0h_131pd_251",
  "header-wrapper": "awsui_header-wrapper_gwq0h_131pd_293",
  "header-actions-wrapper": "awsui_header-actions-wrapper_gwq0h_131pd_305",
  "header-button": "awsui_header-button_gwq0h_131pd_310",
  "header-container-button": "awsui_header-container-button_gwq0h_131pd_310",
  "header-container": "awsui_header-container_gwq0h_131pd_310",
  "header-navigation": "awsui_header-navigation_gwq0h_131pd_345",
  "header-text": "awsui_header-text_gwq0h_131pd_382",
  "content": "awsui_content_gwq0h_131pd_101",
  "content-default": "awsui_content-default_gwq0h_131pd_389",
  "content-footer": "awsui_content-footer_gwq0h_131pd_393",
  "content-expanded": "awsui_content-expanded_gwq0h_131pd_397",
  "content-compact": "awsui_content-compact_gwq0h_131pd_400",
  "focusable": "awsui_focusable_gwq0h_131pd_404",
  "click-target": "awsui_click-target_gwq0h_131pd_419"
};
  